import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { NgxPaginationModule } from 'ngx-pagination';

// Modules
import { ProtocolDroidModule } from './protocol-droid/protocol-droid.module';
import { UiElementsModule } from './ui-elements/ui-elements.module';

import { ChatGPTOptionsComponent } from './components/chatgpt-options/chatgpt-options.component';
import { ModalPromptGeneratorComponent } from './components/chatgpt-options/modal-prompt-generator/modal-prompt-generator.component';
import { FeedbackMessageComponent } from './components/feedback/feedback-message/feedback-message.component';
// Components
import { FeedbackSpinnerComponent } from './components/feedback/feedback-spinner/feedback-spinner.component';
import { NewPageItemComponent } from './components/pages-manager/new-page-item/new-page-item.component';
import { PagesManagerComponent } from './components/pages-manager/pages-manager.component';
import { SentimentAnalysisOptionsComponent } from './components/sentiment-analysis-options/sentiment-analysis-options.component';
import { WebhookOptionsComponent } from './components/webhook-options/webhook-options.component';

const imports = [
  CommonModule,
  ReactiveFormsModule,
  FormsModule,
  NgSelectModule,
  RouterModule,
  BsDropdownModule,
  PopoverModule,
  UiElementsModule,
  ProtocolDroidModule,
  NgxPaginationModule
];

const declarations = [
  ModalPromptGeneratorComponent,
  ChatGPTOptionsComponent,
  WebhookOptionsComponent,
  FeedbackSpinnerComponent,
  SentimentAnalysisOptionsComponent,
  FeedbackMessageComponent,
  PagesManagerComponent,
  NewPageItemComponent
];

@NgModule({
  imports,
  declarations,
  exports: [...imports, ...declarations]
})
export class SharedModule {}
